<script setup lang="ts"></script>

<template>
  <div class="loader-container flex flex-col gap-16">
    <div class="title-container flex flex-col gap-8">
      <w-loading-skeleton class="title-skeleton" height="40px" />
    </div>
    <div class="meta-container flex gap-8">
      <w-loading-skeleton class="channel-skeleton" width="60px" height="24px" />
      <w-loading-skeleton class="status-skeleton" width="90px" height="24px" />
      <w-loading-skeleton class="date-skeleton" width="100%" height="24px" />
    </div>
    <div class="btn-container flex gap-8">
      <w-loading-skeleton class="btn-skeleton" height="44px" />
      <w-loading-skeleton class="btn-skeleton" height="44px" />
    </div>
    <div class="stats-container">
      <div class="stats-loader flex items-center justify-between" v-for="i in 4">
        <div class="text-container flex flex-col gap-8">
          <w-loading-skeleton class="stat-title" width="60px" height="20px" />
          <w-loading-skeleton class="stat-value" width="60px" height="20px" />
        </div>
        <w-loading-skeleton class="stat-value" width="32px" height="32px" />
      </div>
    </div>
    <div class="chart-container">
      <div class="chart-loader flex flex-col gap-8">
        <w-loading-skeleton class="chart-title-skeleton" />
        <w-loading-skeleton class="chart-skeleton" />
      </div>
      <div class="chart-loader flex flex-col gap-8">
        <w-loading-skeleton class="chart-title-skeleton" />
        <w-loading-skeleton class="chart-skeleton" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  @keyframes pulse {
    0% {
      background-color: #e1ecf1;
    }
    50% {
      background-color: #e1ecf1da;
    }
    100% {
      background-color: #e1ecf1;
    }
  }

  .skeleton-element {
    background-color: #edf3f6;
    background-size: 200% 100%;
    animation: pulse 1.5s infinite;
    border-radius: 4px;
    margin: 0;
  }

  .loader-container {
    :deep(.skeleton) {
      @extend .skeleton-element;
      margin: 0;
    }

    .skeleton {
      &.description-skeleton {
        height: 70px !important;
      }

      &.chart-title-skeleton {
        height: 32px !important;
      }

      &.chart-skeleton {
        height: 300px !important;
      }

      @media screen and (min-width: 768px) {
        &.description-skeleton {
          height: 30px !important;
          max-width: 500px;
        }

        &.title-skeleton {
          max-width: 300px;
        }

        &.date-skeleton {
          max-width: 300px;
        }
      }
    }

    .btn-container {
      width: 100%;

      @media screen and (min-width: 768px) {
        justify-content: flex-end;

        & > div.skeleton.btn-skeleton {
          max-width: 120px;
        }
      }
    }
  }

  .stats-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;

    @media screen and (min-width: 768px) {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  .stats-loader {
    padding: 24px;
    border-radius: 12px;
    background: #edf3f6;
    min-height: 120px;
  }

  .chart-container {
    display: grid;
    gap: 24px;

    @media screen and (min-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  .chart-loader {
    background: #edf3f6;
    padding: 24px;
    border-radius: 12px;
  }
</style>
